import Icon from "@mui/material/Icon";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";
import { useThemeMode, writeThemeMode, type ThemeMode } from "../../hooks/useThemeMode";

export const THEME_MODE_OPTIONS: { mode: ThemeMode; icon: string }[] = [
  { mode: "light", icon: "light_mode" },
  { mode: "dark", icon: "dark_mode" },
  { mode: "system", icon: "desktop_windows" },
];

/** Light / Dark / System segmented control. */
export default function ThemeModeToggle() {
  const { t } = useTranslation();
  const mode = useThemeMode();

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={mode}
      onChange={(_, next: ThemeMode | null) => next && writeThemeMode(next)}
      aria-label={t("preferences.theme.label")}
      sx={{ flexShrink: 0, "& .MuiToggleButton-root": { px: 1, py: 0.5 } }}
    >
      {THEME_MODE_OPTIONS.map(({ mode: value, icon }) => (
        <ToggleButton key={value} value={value} aria-label={t(`preferences.theme.${value}`)}>
          <Tooltip title={t(`preferences.theme.${value}`)}>
            <Icon fontSize="small">{icon}</Icon>
          </Tooltip>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
